import { useEffect, useState } from "react";
import api from "@/lib/api";
import DashboardShell from "@/components/nav/DashboardShell";
import { toast } from "sonner";

export default function Billing() {
  const [biz, setBiz] = useState(null);
  const [plans, setPlans] = useState([]);
  const [current, setCurrent] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/business").then(({data}) => setBiz(data));
    api.get("/plans").then(({data}) => setPlans(data));
  }, []);

  const upgrade = async (plan_slug) => {
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        plan_slug,
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Checkout failed");
      setBusy(false);
    }
  };

  return (
    <DashboardShell>
      <div className="brand-eyebrow mb-4">BILLING</div>
      <h1 className="brand-headline text-4xl md:text-6xl mb-8">Plan & billing.</h1>
      <p className="text-smoke max-w-2xl mb-10">Upgrade any time. Payments handled by Stripe. Test cards work in sandbox mode.</p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {plans.map(p => (
          <div key={p.slug} className="border border-line p-6">
            <div className="brand-eyebrow">{p.tier}</div>
            <div className="brand-headline text-3xl mt-3">{p.name}</div>
            <div className="text-white text-2xl mt-2">${p.price_monthly}<span className="text-smoke text-sm">/mo</span></div>
            <div className="text-smoke text-sm mt-2">{p.tagline}</div>
            <button data-testid={`billing-upgrade-${p.slug}`} onClick={() => upgrade(p.slug)} disabled={busy || p.is_contact_sales}
              className={`mt-6 w-full py-3 text-sm font-bold ${p.is_contact_sales ? "border border-line text-smoke cursor-not-allowed" : "bg-gold text-ink hover:bg-white"}`}>
              {p.is_contact_sales ? "Contact sales" : `Upgrade to ${p.name}`}
            </button>
          </div>
        ))}
      </div>
    </DashboardShell>
  );
}
